'use client';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';
import ArrowTop from '@/app/_components/ui/icons/ArrowTop.svg';
import { useState } from 'react';

export default function SpDescription({ summary, content }) {
  const [showMore, setShowMore] = useState(false);
  const [closeSection, setCloseSection] = useState(false);

  return (
    <>
      {(summary || content) && (
        <div
          className="productDescription bg-white mb-3 md:mb-8 p-0 md:p-8"
          id="spDescription"
        >
          <div className="flex md:pb-6 md:pt-0 md:px-0 p-4 justify-between border-b border-light-gray-300 md:border-none">
            <h2 className="font-bold  ">ویژگی های محصول</h2>
            <div
              className="md:hidden"
              onClick={() => setCloseSection((prev) => !prev)}
            >
              <ArrowTop className={`${closeSection && 'rotate-180'}`} />
            </div>
          </div>
          <div
            className={`${
              closeSection
                ? 'mt-0 p-0 h-0 overflow-hidden '
                : 'p-2 md:p-0 mt-4 md:mt-0 '
            }`}
          >
            {summary && (
              <div className="shortProductDesc text-sm md:text-base leading-9">
                <div className="">
                  <div dangerouslySetInnerHTML={{ __html: summary }} />
                </div>
              </div>
            )}
            {content && (
              <div className="mainProductDesc desc text-sm md:text-base mt-4 relative pb-12 overflow-hidden leading-9 text-justify">
                <p className="font-bold pb-4">نقد و بررسی محصول</p>
                <div
                  className={`font-light overflow-hidden ${
                    showMore ? 'h-auto' : 'h-[110px]'
                  }`}
                >
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                  <div
                    className="flex text-sm mt-4 absolute bottom-0 z-10 cursor-pointer flex items-center"
                    onClick={() => setShowMore(!showMore)}
                  >
                    <span className="text-sm font-bold text-ocean-blue">
                      {showMore ? 'بستن' : 'مشاهده بیشتر'}
                    </span>
                    <SmallArrowDown fill="#2A75BB" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
